import Vue from 'vue'
import VueRouter from 'vue-router'

import { canNavigate } from '@/libs/acl/routeProtection'
import { isUserLoggedIn, getUserData, getHomeRouteForLoggedInUser } from '@/auth/utils'
/* CORE */
import app from './routes/app'
/* ADMIN:CORE */
import configs from './routes/Admin/Core/Configs'
import users from './routes/Admin/Core/Users'
import userTypes from './routes/Admin/Core/User_types'
/* ADMIN:DEFINES */
import banks from './routes/Admin/Defines/Banks'
import bankAccounts from './routes/Admin/Defines/Bank_accounts'
import cities from './routes/Admin/Defines/Cities'
import countries from './routes/Admin/Defines/Countries'
import currencies from './routes/Admin/Defines/Currencies'
import customerTypes from './routes/Admin/Defines/Customer_types'
import catalogStatuses from './routes/Admin/Defines/Catalog_statuses'
import contractTemplates from './routes/Admin/Defines/Contract_templates'
import interviewStatuses from './routes/Admin/Defines/Interview_statuses'
import interviewSubjects from './routes/Admin/Defines/Interview_subjects'
import meets from './routes/Admin/Defines/Meets'
import offerStatuses from './routes/Admin/Defines/Offer_statuses'
import offerTerms from './routes/Admin/Defines/Offer_terms'
import productGroupsDefines from './routes/Admin/Defines/Product_groups'
import projectDocumentTypes from './routes/Admin/Defines/Project_document_types'
import projectStatuses from './routes/Admin/Defines/Project_statuses'
import proformaTerms from './routes/Admin/Defines/Proforma_terms'
import sectors from './routes/Admin/Defines/Sectors'
import stockGroups from './routes/Admin/Defines/Stock_groups'
import supplierActivities from './routes/Admin/Defines/Supplier_activities'
import supplierSectors from './routes/Admin/Defines/Suppliers_sector'
import supplierTypes from './routes/Admin/Defines/Supplier_types'
import taxes from './routes/Admin/Defines/Taxes'
import units from './routes/Admin/Defines/Units'
import activities from './routes/Admin/Defines/Activities'
import relatedPersonTypes from './routes/Admin/Defines/Related_person_types'
import purchaseOfferStatus from './routes/Admin/Defines/PurchaseOfferStatus'
import purchaseOfferConfig from './routes/Admin/Defines/PurchaseOfferConfig'
/* ADMIN:APP */
import customers from './routes/Admin/App/Customers'
import customerPrices from './routes/Admin/App/Customer_prices'
import customerAccounts from './routes/Admin/App/Customer_accounts'
import catalogs from './routes/Admin/App/Catalogs'
import contracts from './routes/Admin/App/Contracts'
import interviews from './routes/Admin/App/Interviews'
import offers from './routes/Admin/App/Offers'
import productGroups from './routes/Admin/App/Product_groups'
import products from './routes/Admin/App/Products'
import projects from './routes/Admin/App/Projects'
import proformaInvoices from './routes/Admin/App/Proforma_invoices'
import purchaseOffers from './routes/Admin/App/Purchase_offers'
import reminders from './routes/Admin/App/Reminders'
import messages from './routes/Admin/App/Messages'
import reports from './routes/Admin/App/Reports'
import stocks from './routes/Admin/App/Stocks'
import suppliers from './routes/Admin/App/Suppliers'
import warehouses from './routes/Admin/App/Warehouses'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes: [
    { path: '/', redirect: { name: 'home' } },
    ...app,
    ...configs,
    ...users,
    ...userTypes,
    ...banks,
    ...bankAccounts,
    ...cities,
    ...countries,
    ...currencies,
    ...customerTypes,
    ...catalogStatuses,
    ...contracts,
    ...contractTemplates,
    ...interviewStatuses,
    ...interviewSubjects,
    ...meets,
    ...offerStatuses,
    ...offerTerms,
    ...productGroupsDefines,
    ...projectDocumentTypes,
    ...projectStatuses,
    ...proformaTerms,
    ...purchaseOffers,
    ...purchaseOfferStatus,
    ...purchaseOfferConfig,
    ...sectors,
    ...taxes,
    ...units,
    ...activities,
    ...relatedPersonTypes,
    ...customers,
    ...customerPrices,
    ...customerAccounts,
    ...catalogs,
    ...interviews,
    ...offers,
    ...productGroups,
    ...products,
    ...projects,
    ...proformaInvoices,
    ...reminders,
    ...messages,
    ...reports,
    ...stocks,
    ...stockGroups,
    ...suppliers,
    ...supplierActivities,
    ...supplierSectors,
    ...supplierTypes,
    ...warehouses,
    {
      path: '*',
      redirect: 'error-404',
    },
  ],
})

router.beforeEach((to, _, next) => {
  const isLoggedIn = isUserLoggedIn()

  if (!canNavigate(to)) {
    // Redirect to login if not logged in
    if (!isLoggedIn) return next({ name: 'auth-login' })

    // If logged in => not authorized
    return next({ name: 'misc-not-authorized' })
  }

  // Redirect if logged in
  if (to.meta.redirectIfLoggedIn && isLoggedIn) {
    const userData = getUserData()
    next(getHomeRouteForLoggedInUser(userData ? userData.role : null))
  }

  return next()
})

// ? For splash screen
// Remove afterEach hook if you are not using splash screen
router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = 'none'
  }
})

export default router
